<div>
    <form [formGroup]="baseFormGroup" #f="ngForm" class="">
        <!-- Vrsta troška -->
      <div class="row">
        <!-- RB -->
        <div class="col-1">
          <div class="form-group row">
            <div class="col-md-12">
              <yt-number-input-v3
                                  #autofocus
                                  name="txtRB"
                                  [Label]="'IZVODSTAVKA.RB.SINGULAR'"
                                  formControlName="RB"
                                  [FormatString]="'1.0-0'">
              </yt-number-input-v3>
              <div class="form-error" *ngIf="submitted && fc.RB.invalid">
                <span *ngFor="let validation of errorMessages.RB">
                  <span class="error-message" *ngIf="fc.RB.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="form-group row">
            <div class="col-md-12">
              <yt-dropdown-picklist
                                    [ModelName]="'komitent'"
                                    [GetName]="'get'"
                                    [ModelProperty]="'SNaziv,Mesto'"
                                    [OrderBy]="'SNaziv'"
                                    [AllowAddNew]="true"
                                    [AllowEdit]="true"
                                    formControlName="KomitentID"
                                    [Label]="'IZVODSTAVKA.KOMITENT.SINGULAR'"
                                    [ngClass]="{'is-invalid': submitted && fc.KomitentID.invalid}"
                                    [Width]="'xl'"
                                    [Position]="'left'">
              </yt-dropdown-picklist>
              <div class="form-error" *ngIf="submitted && fc.KomitentID.invalid">
                <span *ngFor="let validation of errorMessages.KomitentID">
                  <span class="error-message" *ngIf="fc.KomitentID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-4" *ngIf="false">
          <div class="form-group row">
            <div class="col-md-12">
              <yt-input
                        [Type]="'text'"
                        [Label]="'IZVODSTAVKA.BROJFAKTURE.SINGULAR'"
                        formControlName="BrojFakture"
                        [MaxLength]="20"
                        [ngClass]="{'is-invalid': submitted && fc.BrojFakture.invalid}">
              </yt-input>
              <div class="form-error" *ngIf="submitted && fc.BrojFakture.invalid">
                <span *ngFor="let validation of errorMessages.BrojFakture">
                  <span class="error-message" *ngIf="fc.BrojFakture.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="form-group row">
            <div class="col-md-12">
              <yt-dropdown-picklist #dropDownPickListComponent
                                    [ModelName]="'fakdokument'"
                                    [GetName]="'GetFaktByKomitent'"
                                    [GetParameters]='parameterList'
                                    [TableColumns]="TableColumnsFakDokum"
                                    [ModelProperty]="'BrojDokumenta,Komitent'"
                                    formControlName="BrojFaktureIzMinibiz"
                                    [Label]="'IZVODSTAVKA.FAKDOKUMIZMINIBIZA.SINGULAR'"
                                    [AllowAddNew]="false"
                                    [AllowEdit]="false"
                                    [Required]="false">
              </yt-dropdown-picklist>
              <div class="form-error" *ngIf="submitted && fc.BrojFaktureIzMinibiz.invalid">
                <span *ngFor="let validation of errorMessages.BrojFaktureIzMinibiz">
                  <span class="error-message" *ngIf="fc.BrojFaktureIzMinibiz.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
              </div>
              <div class="form-error" *ngIf="submitted && baseFormGroup.errors?.faktureConflict">
                <span class="error-message">
                  <span translate="{{ baseFormGroup.errors.faktureConflict.message }}"></span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-3">
          <div class="form-group row">
            <div class="col-md-12">
              <yt-input [Type]="'text'"
                        [Label]="'IZVODSTAVKA.FAKDOKUMNIJEIZMINIBIZA.SINGULAR'"
                        formControlName="BrojFaktureNijeMinibiz"
                        [MaxLength]="20"
                        [ngClass]="{'is-invalid': submitted && fc.BrojFaktureNijeMinibiz.invalid}">
              </yt-input>
              <div class="form-error" *ngIf="submitted && fc.BrojFaktureNijeMinibiz.invalid">
                <span *ngFor="let validation of errorMessages.BrojFaktureNijeMinibiz">
                  <span class="error-message" *ngIf="fc.BrojFakture.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
              </div>
              <div class="form-error" *ngIf="submitted && baseFormGroup.errors?.faktureConflict">
                <span class="error-message">
                  <span translate="{{ baseFormGroup.errors.faktureConflict.message }}"></span>
                </span>
              </div>              
            </div>
          </div>
        </div>
        <!-- <div class="col-lg-4 col-4" *ngIf="false">
      <div class="form-group row">
          <div class="col-md-12">
              <yt-dropdown-picklist
                  #autofocus
                  [ModelName]="'nacinplacanja'"
                  [GetName]="'get'"
                  [ModelProperty]="'Naziv'"
                  [OrderBy]="'Naziv'"
                  [AllowAddNew]="true"
                  formControlName="NacinPlacanjaID"
                  [Label]="'IZVODSTAVKA.NACINPLACANJA.SINGULAR'"
                  >
              </yt-dropdown-picklist>
              <div class="form-error" *ngIf="submitted && fc.NacinPlacanjaID.invalid">
                  <span *ngFor="let validation of errorMessages.NacinPlacanjaID">
                    <span class="error-message" *ngIf="fc.NacinPlacanjaID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
              </div>
          </div>
      </div>
  </div>              -->
      </div>        
          <div class="row">
            <div class="col-lg-4 col-4">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-dropdown-picklist 
                            [ModelName]="'orgjed'"
                            [GetName]="'getParentAndChildByParentID'"
                            [ModelProperty]="'Naziv'"
                            [OrderBy]="'Naziv'"
                            formControlName="OrgJedID"
                            [Label]="'IZVODSTAVKA.ORGJED.SINGULAR'"  
                            [ngClass]="{'is-invalid': submitted && fc.OrgJedID.invalid}"
                            (GetItems)="SkupiOrgJed($event)"
                        >
                        </yt-dropdown-picklist>
                        <div class="form-error" *ngIf="submitted && fc.OrgJedID.invalid">
                            <span *ngFor="let validation of errorMessages.OrgJedID">
                              <span class="error-message" *ngIf="fc.OrgJedID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                          </span>
                        </div>                              
                    </div>
                </div>
            </div>
              <div class="col-lg-4 col-4">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <yt-number-input-v3 name="txtDuguje"
                                          [Label]="'IZVODSTAVKA.DUGUJE.SINGULAR'"
                                          formControlName="Duguje">
                      </yt-number-input-v3>
                      <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                        <span class="error-message"
                              *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkDugujePotrazuje && !this.baseFormGroup.errors.checkDugujePotrazuje.valid">
                          <span translate="{{this.baseFormGroup.errors.checkDugujePotrazuje.message}}"></span>
                        </span>
                      </div>
                      <!-- <div class="form-error" *ngIf="submitted && fc.Duguje.invalid">
      <span *ngFor="let validation of errorMessages.Duguje">
        <span class="error-message" *ngIf="fc.Duguje.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
    </span>
  </div> -->
                    </div>
                  </div>
              </div>
              <div class="col-lg-4 col-4">
                  <div class="form-group row">
                      <div class="col-md-12">
                          <yt-number-input-v3
                              name="txtPotrazuje"                                 
                              [Label]="'IZVODSTAVKA.POTRAZUJE.SINGULAR'" 
                              formControlName="Potrazuje"
                              >
                          </yt-number-input-v3>
                          <!-- <div class="form-error" *ngIf="submitted && fc.Potrazuje.invalid">
                              <span *ngFor="let validation of errorMessages.Potrazuje">
                                <span class="error-message" *ngIf="fc.Potrazuje.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                            </span>
                          </div> -->
                      </div>
                  </div>
              </div>
          </div> 
          <div class="row">
              <div class="col-lg-12 col-12">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <yt-text-area [MaxLength]="250" name="txtOpis" formControlName="Opis" [Label]="'IZVODSTAVKA.OPIS.SINGULAR'">
                      </yt-text-area>
                      <div class="form-error" *ngIf="submitted && fc.Opis.invalid">
                            <span *ngFor="let validation of errorMessages.Opis">
                            <span class="error-message" *ngIf="fc.Opis.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                        </span>
                        </div>
                    </div>
                  </div>
                </div>
          </div> 
    </form>
  </div>
